// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"28780428","644":"bc67beca"}[chunkId] + ".chunk.js";
};